import { render } from "./OnlineOrderReasonComponent.vue?vue&type=template&id=6ad47e4c"
import script from "./OnlineOrderReasonComponent.vue?vue&type=script&lang=js"
export * from "./OnlineOrderReasonComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/onlineOrders/OnlineOrderReasonComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ad47e4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ad47e4c', __exports__)) {
    api.reload('6ad47e4c', __exports__)
  }
  
  module.hot.accept("./OnlineOrderReasonComponent.vue?vue&type=template&id=6ad47e4c", () => {
    api.rerender('6ad47e4c', render)
  })

}


export default __exports__